import { useActionless, useAppSelector } from 'app-redux/hooks'
import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import Icon from 'components/elements/Icon'

import { getDeckPriceAndInfo } from 'utils/calculateDeckPrice'
import { getPriceStringFromFloat } from 'utils/Price'
import { copyCardNamesToClipboard } from 'utils/cardsToClipboard'
import { buyFromDropdown } from 'components/formElements/BuyCardsLink'

import styles from './highlightedCardControls.module.scss'

const HighlightedCardControls = () => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const highlightedCards = useAppSelector(state => state.active.highlightedCards)
  const cardMap = useAppSelector(state => state.deck.cardMap)
  const categories = useAppSelector(state => state.deck.categories)
  const priceSource = useAppSelector(state => state.active.priceSource)

  const cards = Object.keys(highlightedCards).map(id => cardMap[id])
  const totalHighlighted = cards.reduce((acc, card) => acc + (card?.qty || 0), 0)
  const { estDeckCost } = getDeckPriceAndInfo(cards, categories, priceSource)
  const estPrice = getPriceStringFromFloat(estDeckCost, priceSource[0])

  const handleSwitchCardsToSelected = () => {
    setActiveState({ multiSelectedIds: highlightedCards })
    setTimeout(() => setActiveState({ highlightedCards: {} }), 50) // Fixes timing issue with the floating menu changing multiple at once
  }

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <label>{totalHighlighted} Card(s) Focused</label>
        <label className={styles.selectedPrice}>Focused price {estPrice}</label>
      </div>
      <div className={styles.controls}>
        <button className={styles.button} onClick={() => setActiveState({ highlightedCards: {} })}>
          <Icon name="close" /> <span>Cancel</span>
        </button>

        <ArchidektDropdown
          triggerClassName={styles.dropdownTrigger}
          menuClassName={styles.quickOptions}
          defaultTriggerClassName={styles.defaultTrigger}
          direction="up"
          options={[
            { label: 'Switch cards to selected', icon: 'refresh', onClick: handleSwitchCardsToSelected },
            { type: 'spacer' },
            buyFromDropdown(Object.keys(highlightedCards), priceSource[0], 'multi-select'),
            {
              type: 'extras',
              label: 'Copy to clipboard',
              icon: 'copy',
              id: 'copy-to-clipboard-options',
              options: [
                {
                  label: 'Card names only',
                  onClick: () => copyCardNamesToClipboard(cards),
                },
                {
                  label: 'Card name with quantities',
                  onClick: () => copyCardNamesToClipboard(cards, true),
                },
              ],
            },
          ]}
        />
      </div>
    </div>
  )
}

export default HighlightedCardControls
